// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PEyeCloseOutlinedSvg from "@fishx/icons-svg/es/asn/PEyeCloseOutlined";
import FishxIcon from '../components/FishxIcon';

var PEyeCloseOutlined = function PEyeCloseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PEyeCloseOutlinedSvg
  }));
};

PEyeCloseOutlined.displayName = 'PEyeCloseOutlined';
export default React.forwardRef(PEyeCloseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PEyeCloseOutlined.js
// module id = 3365
// module chunks = 0